var p = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, u = (t) => !t || typeof t != "object" || Object.keys(t).length === 0, b = (t, e) => JSON.stringify(t) === JSON.stringify(e);
function n(t, e) {
  t.forEach(function(s) {
    Array.isArray(s) ? n(s, e) : e.push(s);
  });
}
function y(t) {
  let e = [];
  return n(t, e), e;
}
var c = (...t) => y(t).filter(Boolean), l = (t, e) => {
  let s = {}, o = Object.keys(t), i = Object.keys(e);
  for (let r of o) if (i.includes(r)) {
    let a = t[r], f = e[r];
    Array.isArray(a) || Array.isArray(f) ? s[r] = c(f, a) : typeof a == "object" && typeof f == "object" ? s[r] = l(a, f) : s[r] = f + " " + a;
  } else s[r] = t[r];
  for (let r of i) o.includes(r) || (s[r] = e[r]);
  return s;
}, g = (t) => !t || typeof t != "string" ? t : t.replace(/\s+/g, " ").trim();
export {
  p as a,
  u as b,
  b as c,
  y as e,
  c as f,
  l as g,
  g as h
};
